import { ListItem, ListItemText } from '@material-ui/core';
import React from 'react';

import CheckCircleIcon from 'assets/icons/check-circle.svg';
import Img from 'retired/Img';
import { purple } from 'utils/color-styles';
import { Nonprofit, NonprofitIdentifierType } from 'generated/graphql';
import { renderAddress } from 'utils/renderAddress';

const Option = ({ nonprofit }: { nonprofit: Nonprofit }) => {
  const { locationObject } = nonprofit;
  const location = renderAddress(locationObject);
  const ncesIdentifier = nonprofit.identifiers?.find(
    (identifier) => identifier.type === NonprofitIdentifierType.Nces
  );
  return (
    <ListItem title={nonprofit.name}>
      <ListItemText
        primary={
          <div style={{ display: 'flex' }}>
            <div style={{ color: purple }}>
              {nonprofit.name}{' '}
              {nonprofit.ein ? (
                <> – EIN: {nonprofit.ein}</>
              ) : ncesIdentifier ? (
                <> – NCES ID: {ncesIdentifier.id}</>
              ) : null}
            </div>

            {nonprofit.approved && (
              <div>
                <Img
                  src={CheckCircleIcon}
                  style={{
                    width: '20px',
                    marginLeft: 6,
                  }}
                  alt="Approved"
                  title="Approved"
                />
              </div>
            )}
          </div>
        }
        secondary={<>{location}</>}
      />
    </ListItem>
  );
};

export default Option;
